import formatCallDuration from '../../utils/formatCallDuration';
import React, { useState } from 'react';
import { FaVideo, FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import ActiveCall from './ActiveCall';
import CallLobby from './CallLobby';
import './MeetingWindow.css';

const MeetingWindow = ({ meeting, tokens, onClose, startJoined = false }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [callDuration, setCallDuration] = useState(0);
    const [participantCount, setParticipantCount] = useState(1);
    const [hasJoined, setHasJoined] = useState(startJoined || false);
    const [initialSettings, setInitialSettings] = useState({ isMuted: false, isVideoOff: false });

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    const handleCallEnd = () => {
        onClose();
    };

    const handleCloseClick = () => {
        onClose();
    };

    const handleJoinClick = (settings) => {
        setInitialSettings(settings);
        setHasJoined(true);
    };



    if (!meeting || !tokens) return null;

    return (
        <>
            <div className={`meeting-window ${isCollapsed ? 'collapsed' : 'open'} ${!hasJoined ? 'is-lobby' : ''}`}>
                {isCollapsed && (
                    <div className="meeting-tab" onClick={toggleCollapse}>
                        <div className="tab-content">
                            <FaVideo />
                            <span className="tab-participants">
                                {participantCount} participant{participantCount > 1 ? 's' : ''}
                            </span>
                            <span className="tab-duration">{formatCallDuration(callDuration)}</span>
                        </div>
                    </div>
                )}

                <div className="meeting-window-content">
                    <div className="meeting-window-header">
                        <div className="meeting-window-title">
                            <h3>{meeting.title}</h3>
                        </div>
                        <div className="meeting-window-actions">
                            <button
                                className="collapse-btn"
                                onClick={toggleCollapse}
                                title={isCollapsed ? 'Expand' : 'Collapse'}
                            >
                                {isCollapsed ? <FaChevronLeft /> : <FaChevronRight />}
                            </button>
                            <button
                                className="close-pane-btn"
                                onClick={handleCloseClick}
                                title="Close Meeting"
                            >
                                <FaTimes />
                            </button>
                        </div>
                    </div>

                    {!hasJoined ? (
                        <CallLobby 
                            meeting={meeting} 
                            onJoin={handleJoinClick} 
                            onCancel={handleCallEnd} 
                        />
                    ) : (
                        <ActiveCall
                            meeting={meeting}
                            tokens={tokens}
                            callType={meeting.call_type || 'video'}
                            onLeave={handleCallEnd}
                            onDurationChange={setCallDuration}
                            onParticipantCountChange={setParticipantCount}
                            initialAudioMuted={initialSettings.isMuted}
                            initialVideoMuted={initialSettings.isVideoOff || meeting.call_type === 'voice'}
                        />
                    )}
                </div>
            </div>

            {/* Overlay for mobile to close on backdrop click */}
            {!isCollapsed && (
                <div className="meeting-window-overlay" onClick={toggleCollapse}></div>
            )}
        </>
    );
};

export default MeetingWindow;
